import { ComparisonRowConfig } from '../types';

export const COMPARISON_ROWS: ComparisonRowConfig[] = [
  { key: 'approvedAmount', label: 'Approved Amount', format: 'currency', bestIs: 'highest' },
  { key: 'interestRate', label: 'Interest Rate', format: 'percentage', bestIs: 'lowest' },
  { key: 'termLengthMonths', label: 'Term Length', format: 'months', bestIs: 'highest' },
  { key: 'monthlyPayment', label: 'Monthly Payment', format: 'currency', bestIs: 'lowest' },
  { key: 'conditions', label: 'Conditions', format: 'number', bestIs: 'lowest' },
];

export const DEFAULT_VISIBLE_CONDITIONS = 5;
